// this is an autogenerated file from DesignSystem/CheckInAction/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_CheckInAction($patient_id: uuid!, $organization_id: uuid!) {
  notes: vaxiom_notes(
    where: {
      patient: { _id: { _eq: $patient_id } }
      target_type: { _eq: "Patient.CheckIn" }
    }
  ) {
    id
    note
    sys_created
    author_user {
      id
      person {
        id
        first_name
        middle_name
        last_name
      }
    }
  }
  settings: vaxiom_location_access_keys(
    where: {
      organization: { _id: { _eq: $organization_id } }
      access_name: { _eq: "PATIENT_CHECKIN" }
    }
  ) {
    id
    settings {
      id: location_access_key_id
      max_minutes_late
      max_due_amount
      due_period
      max_due_amount_insurance
      due_period_insurance
    }
  }
  patient_past_due: financial_patient_due_amount(
    args: { _patient_id: $patient_id }
    distinct_on: [payment_account_id]
  ) {
    id: payment_account_id
    due_now
    due_30_days
    due_60_days
    due_90_days
    due_120_days
    payment_account {
      id
      account_type
    }
  }
}

`